let tabClass = "user-is-tabbing";

//handle the focus ring highlighting
function handleFirstTab(e: KeyboardEvent) {
    if (e.keyCode === 9) {
        forceTabBehavior();
    }
}
  
function handleMouseDownOnce() {
    document.body.classList.remove(tabClass);
    
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

export function forceTabBehavior() {
    document.body.classList.add(tabClass);

    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
}

window.addEventListener('keydown', handleFirstTab);